import React, {Component} from "react";
import Link from "../../../../lib/components/Link/Link";
import PropTypes from "prop-types";
import GemForm from "../../site/gem/components/GemForm";

class LinkCardMain extends Component {

  render() {
    return <GemForm>
      <Link to={this.props.link} asHref={this.props.asHref} className={'group sm:col-span-' + this.props.numOfColumns +
        ' lg:col-span-' + this.props.numOfColumns +
        ' block p-5 rounded-xl border border-white/10 bg-white/5 hover:-translate-y-1 transition-all hover:shadow-xl bg-gradient-to-br from-kiwiAcc to-green-500'}>

          <div className="mb-4 h-[60px]">
            {this.props.title}
            <span className="inline-flex items-center gap-1 mt-4 font-semibold text-[#C] text-black">Mehr
              <span className="transform transition group-hover:translate-x-1">→</span>
            </span>
          </div>
      </Link>
    </GemForm>;
  }
}

LinkCardMain.propTypes = {
  link: PropTypes.string,
  numOfColumns: PropTypes.string,
  title: PropTypes.string,
  asHref: PropTypes.bool
}
export default LinkCardMain;
